import { render, staticRenderFns } from "./ShipmentsReportsView.vue?vue&type=template&id=27b15c00&scoped=true&"
import script from "./ShipmentsReportsView.vue?vue&type=script&lang=js&"
export * from "./ShipmentsReportsView.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentsReportsView.vue?vue&type=style&index=0&id=27b15c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b15c00",
  null
  
)

export default component.exports